var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeinline = function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.87 5.312c0-1.757-1.293-3.171-2.89-3.171A141 141 0 0 0 10.352 2H9.65c-2.25 0-4.462.04-6.626.14C1.43 2.14.137 3.563.137 5.32A57 57 0 0 0 0 9.492q-.006 2.084.133 4.175c0 1.758 1.293 3.184 2.887 3.184 2.274.105 4.606.152 6.978.148q3.562.014 6.977-.148c1.598 0 2.891-1.426 2.891-3.184a60 60 0 0 0 .133-4.18 57 57 0 0 0-.129-4.175M8.087 13.324V5.648l5.665 3.836z"
  })));
};
export default SvgYoutubeinline;